import { Pipe, PipeTransform } from '@angular/core';
import { MembershipBenefitInterface } from '../interface/motor.interface';

@Pipe({
  name: 'filterBenefits'
})

export class FilterBenefitsPipe implements PipeTransform {
  transform(benefits: MembershipBenefitInterface[], membershipId: string): MembershipBenefitInterface[] {
    return benefits
      .filter(benefit => benefit.motorMembershipId === membershipId)
      .sort((a, b) => a.seq - b.seq);
  }
}